import { toast } from 'react-toastify'
import { useLocation, useNavigate } from 'react-router-dom'
import useGetInitBoxPaymentOs from '../../../../pages/easyPay/initMoneyPool/hooks/useGetInitBoxPaymentOs'
import useSetGatewayPayment from '../hooks/useSetGatewayPeyment'

interface IFooterGatewayPaymentProps {
    total: number
    commission: number
    destination: string
    gateway: IGateway
    isSelected?: { saderat: boolean; parsian: boolean }
    isWallet?: boolean
    Amount?: number
    toBePaidTransactions?: object
}

export default function FooterInitGateway({
    total,
    commission,
    destination,
    gateway,
    isWallet,
    Amount,
    toBePaidTransactions,
}: IFooterGatewayPaymentProps) {
    const { mutate } = useSetGatewayPayment()
    const profile = JSON.parse(localStorage.getItem('profile')!)
    const { data } = useGetInitBoxPaymentOs(profile?.id)
    const { state } = useLocation()
    const navigate = useNavigate()
    const paymentItems: IPaymentItems[] = state?.toBePaidTransactions.map(
        (payment) => ({
            itemAmount: payment.amount,
            itemType: payment.type,
            itemId: payment.id,
            box_id: payment.box_id,
            commission: payment.commission,
            description: payment.description,
        })
    )
    return (
        <div className=" w-full">
            <div
                className=" mx-8 rounded-3xl  bg-green-1 text-white text-center py-3 my-2 cursor-pointer"
                onClick={() => {
                    if (!gateway?.uniqueCode) {
                        toast.error('نوع درگاه پرداخت را انتخاب کنید')
                        return
                    }
                    if (data) {
                        if (Amount) {
                            mutate({
                                paymentItems: paymentItems,
                                gateway: {
                                    uniqueCode: gateway.uniqueCode,
                                },
                                clientType: 'pwa',
                            })
                        } else {
                            localStorage.setItem(
                                'toBePaidTransactions',
                                JSON.stringify({
                                    type: 'group-all-payment',
                                    data: state.toBePaidTransactions,
                                    //@ts-ignore
                                    pk: null,
                                    //@ts-ignore
                                    gateway: null,
                                })
                            )
                            navigate('/group-all-payment')
                        }
                    }
                }}
            >
                پرداخت درگاهی(جدید)
            </div>
        </div>
    )
}
